module.exports = __webpack_public_path__ + "media/public/fonts/QanelasLight/QanelasLight-7f3668fba739e49bfeb72e49718ddfa1.woff";